import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockTakeService = {
    saveStockTake,
    getStockTakeList,
    getStockTakeDetailList,
    exportStockTakeDetailExcel,
    takeStock,
};

function saveStockTake(stockTake) {
    return axios.post("/auth/stock-take", stockTake);
}

function getStockTakeList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    return axios.get("/auth/stock-takes", { params });
}

function getStockTakeDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }

    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }

    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }

    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }

    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }

    return axios.get("/auth/stock-take-details/" + searchParams.id, { params });
}

function exportStockTakeDetailExcel(searchParams) {
    let params = {};

    if (searchParams.id) {
        params["id"] = searchParams.id;
    }

    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }

    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }

    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }

    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }

    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-take-detail-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function takeStock(id) {
    return axios.get("/auth/stock-take/" + id);
}